// 导出 g-base 中的 types
export * from '@antv/g-base/lib/types';
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g-canvas@0.4.14@@antv/g-canvas/esm/types.js
// module id = eQ4p
// module chunks = 14